import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
    key: "curriculumPersist",
    storage: localStorage, // localStorage 사용
});

// 저장된 커리큘럼 버전 (localStorage에서 유지됨)
export const savedCurriculumVersionState = atom({
    key: "savedCurriculumVersionState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});

// 저장된 커리큘럼 데이터 (localStorage에서 유지됨)
export const curriculumState = atom({
    key: "curriculumState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});

// 저장된 커리큘럼 데이터 (localStorage에서 유지됨)
export const inAppCurriculumState = atom({
    key: "inAppCurriculumState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});

// 서버에서 가져온 최신 버전 (메모리 상태)
export const serverCurriculumVersionState = atom({
    key: "serverCurriculumVersionState",
    default: null,
});